module.exports = __webpack_public_path__ + "img/svgexport-1.87b45980.svg";